import { render } from "./LuckyStatisticsBS.vue?vue&type=template&id=1eee9176"
import script from "./LuckyStatisticsBS.vue?vue&type=script&lang=js"
export * from "./LuckyStatisticsBS.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__